import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarComponent} from "../snack-bar/snack-bar.component";

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {
    constructor(
        private snackBar: MatSnackBar
    ) {}

    showNotification(displayMessage, messageType, position?): void {
        let cls = 'default-notification-overlay';
        if (messageType === 'success') {
            cls = 'success-notification-overlay';
        } else if (messageType === 'warning') {
            cls = 'warning-notification-overlay';
        } else if (messageType === 'error') {
            cls = 'error-notification-overlay';
        } else if (messageType === 'info') {
            cls = 'info-notification-overlay';
        }
        this.snackBar.openFromComponent(SnackBarComponent, {
            data: {
                message: displayMessage,
            },
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: position ? position : 'top',
            panelClass: cls
        });
    }
}
